import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* markLookbookOrderPlaced({ payload: { id, orderId, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.orders.markPlaced, pathParams: { id, orderId } });

    onSuccess && onSuccess();
    yield put(actions.markLookbookOrderPlacedDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.markLookbookOrderPlacedFailed,
      handledErrors,
      endpoint: api.lookbooks.orders.markPlaced.url
    });
  }
}

export const markLookbookOrderPlacedSaga = takeEvery(types.MARK_LOOKBOOK_ORDER_PLACED_REQUEST, markLookbookOrderPlaced);
